/* *
 * module の管理
 * src/store/modules に新しい定義を追加したら
 * 下記の store 変数に追記する
 */
import Vue from 'vue'
import Vuex from 'vuex'

// getter, mutation, action 等は下記で定義
import auth from './modules/auth'
import signup from './modules/signup'
import directtalk from './modules/directtalk'
import chatbot from './modules/chatbot'
import calendar from './modules/calendar'
import setting from './modules/setting'
import employmentPage from './modules/employmentPage'
import help from './modules/help'
import tools from './modules/tools'
import webRTC from './modules/webRTC'
import mediapool from './modules/mediapool'
import virtualOffice from './modules/virtualOffice'
import sitemap from './modules/users/sitemap'
import master from './modules/master'
import task from './modules/task'
import wait4 from './modules/wait4'
import schedule from './modules/schedule'
import mailsms from './modules/mailsms'

// アプリケーション構造化後のvuexパス
// ToDo
// 最終的にこのindex.jsは@hrm-frontend/store/に移動する
import company from './modules/company/company-store'
import recruitmentMedia from './modules/recruitment-media/recruitment-media-store'
import background from './modules/background/background-store'
import frontendLog from './modules/frontend-log/frontend-log-store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    signup,
    directtalk,
    chatbot,
    calendar,
    setting,
    employmentPage,
    help,
    tools,
    webRTC,
    mediapool,
    virtualOffice,
    sitemap,
    master,
    task,
    wait4,
    schedule,
    mailsms,
    // 会社関連ストア
    company,
    // 媒体連携関連ストア
    recruitmentMedia,
    // バックグランド処理関連ストア
    background,
    // フロントエンドログ関連ストア
    frontendLog,
  }
  // plugins: [plugin],
  // strict: process.env.NODE_ENV !== 'production'
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js